import h from 'hyperscript';
import convertElapsedTime from 'javascripts/utils/convert-elapsed-time';
import { generateIcon } from 'components/_particles/icon/icon';
import getTenantColor from 'javascripts/utils/get-tenant-color';

class AudioPlayer {
  constructor($el) {
    this.$el = $el;
    this.$audioPlayer = $el.querySelector('.audio-player-box__player');
    const { src } = this.$audioPlayer.dataset;

    if (!src) throw new Error('No audio src specified');

    this.audioSrc = src;

    this.$playIcon = generateIcon({ icon: 'play', className: 'audio-player-box__control-icon' });
    this.$pauseIcon = generateIcon({ icon: 'pause', className: 'audio-player-box__control-icon' });

    this.tenantColor = getTenantColor();

    this.initAudioPlayer();
  }

  handleLoadedMetaData = (event) => {
    const { duration, currentTime } = event.target;

    this.$currentTime.innerHTML = convertElapsedTime(currentTime);
    this.$duration.innerHTML = convertElapsedTime(duration);
    this.audioDuration = duration;
  };

  initAudioPlayer = () => {
    this.$audio = h('audio.audio-player-box__audio', {
      src: this.audioSrc,
      onloadedmetadata: this.handleLoadedMetaData,
      ontimeupdate: this.handleAudioTimeUpdate,
    });

    this.$controlButton = h(
      'button.audio-player-box__control-button',
      {
        type: 'button',
        onclick: this.handleControlButtonClick,
      },
      this.$playIcon,
    );

    this.$progress = h('canvas.audio-player-box__progress', {
      height: 20,
      width: 0,
    });

    this.$progressCanvas = this.$progress.getContext('2d');

    this.$currentTime = h('span.audio-player-box__current-time', '00:00');
    this.$duration = h('span.audio-player-box__duration', '00:00');

    const $timeContainer = h('div.audio-player-box__time', this.$currentTime, '/', this.$duration);

    const $audioPlayerContainer = h(
      'div.audio-player-box__player-inner',
      this.$audio,
      this.$controlButton,
      this.$progress,
      $timeContainer,
    );

    this.$audioPlayer.appendChild($audioPlayerContainer);

    this.progressWidth = this.$progress.offsetWidth;
    this.$progress.width = this.progressWidth;

    this.audioDuration = 0;
    this.audioCurrentTime = 0;

    this.$progress.addEventListener('click', this.handleJumpAudio);
    window.addEventListener('resize', this.handleResize);
  };

  handleResize = () => {
    this.$progress.width = 0;
    this.progressWidth = this.$progress.offsetWidth;
    this.$progress.width = this.progressWidth;
  }

  handleAudioTimeUpdate = (event) => {
    const { currentTime } = event.target;

    const percentage = currentTime / this.audioDuration;
    const progress = this.progressWidth * percentage;

    this.updateProgress(progress, currentTime);
  };

  updateControlIcon = () => {
    while (this.$controlButton.lastChild) {
      this.$controlButton.removeChild(this.$controlButton.lastChild);
    }

    if (this.$audio.paused) {
      this.$controlButton.appendChild(this.$playIcon);
    } else {
      this.$controlButton.appendChild(this.$pauseIcon);
    }
  };

  handleControlButtonClick = () => {
    if (!Number.isNaN(this.$audio.duration)) {
      this.$audio.currentTime = this.audioCurrentTime;
    }
    if (this.$audio.paused) {
      this.$audio.play();
    } else {
      this.$audio.pause();
    }
    this.updateControlIcon();
  };

  handleJumpAudio = (event) => {
    const rect = this.$progress.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const percentage = x / this.progressWidth;
    const progress = this.progressWidth * percentage;
    let currentTime = this.audioDuration * percentage;

    if (currentTime > this.audioDuration) { currentTime = this.audioDuration; }

    this.updateProgress(progress, currentTime);
    if (!Number.isNaN(this.$audio.duration)) {
      this.$audio.currentTime = currentTime;
    }
  }

  updateProgress(progress, currentTime) {
    this.$progressCanvas.clearRect(0, 0, this.progressWidth, 20);

    if (this.audioDuration === currentTime) {
      this.updateControlIcon();
    }

    this.$currentTime.innerHTML = convertElapsedTime(currentTime);

    this.$progressCanvas.fillStyle = this.tenantColor;
    this.$progressCanvas.fillRect(0, 0, progress, 20);
    this.audioCurrentTime = currentTime;
  }
}

document.querySelectorAll('.audio-player-box').forEach($el => new AudioPlayer($el));
